import IRoute from "./IRoute";
import getPath from "../utils/getPath";

export default function getRouteList(routes: Array<IRoute>): Array<IRoute> {
  const plainRouteList: Array<IRoute> = [];

  for (const route of routes) {
    plainRouteList.push({
      ...route,
      children: undefined,
    });

    if (route.children) {
      plainRouteList.push(...getRoutesForParent(route.path, route.children));
    }
  }

  return plainRouteList;
}

function getRoutesForParent(
  basePath: string,
  children: Array<IRoute>
): Array<IRoute> {
  const routes: Array<IRoute> = [];
  for (const child of children) {
    const path = getPath(basePath, child.path);
    routes.push({
      ...child,
      path,
      children: undefined,
    });
    if (child.children) {
      routes.push(...getRoutesForParent(path, child.children));
    }
  }

  return routes;
}
